import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PartialPractice } from "./schema"
import { PracticeInviteWithContext } from "../Practice/schema"
import { DataStatus } from "../enums"
import { Provider } from "../Provider/schema"

export interface PracticesDataStatus {
  practicesDataStatus: DataStatus
  detachedProvidersDataStatus: DataStatus
  practiceInvitesDataStatus: DataStatus
}

export interface PracticesState {
  practices: PartialPractice[]
  detachedProviders: Provider[]
  // Note: Theres is a seperate notion of practice invites on a
  // practice versus practice invites for the given user.
  // we will need this in different parts of the app given the new data router design
  practiceInvites: PracticeInviteWithContext[]
  linkedInviteId?: string
  dataStatuses: PracticesDataStatus
}
const initialPracticesState: PracticesState = {
  practices: [],
  detachedProviders: [],
  practiceInvites: [],
  dataStatuses: {
    practicesDataStatus: DataStatus.LOADING,
    detachedProvidersDataStatus: DataStatus.LOADING,
    practiceInvitesDataStatus: DataStatus.LOADING,
  },
}

// TODO: rename this 'onboarding' instead of 'practices'
export const practicesSlice = createSlice({
  name: "practices",
  initialState: initialPracticesState,
  reducers: {
    setPractices: (state, action: PayloadAction<PartialPractice[]>) => {
      state.practices = action.payload
    },
    setDetachedProviders: (state, action: PayloadAction<Provider[]>) => {
      state.detachedProviders = action.payload
    },
    updatePractice: (state, action: PayloadAction<PartialPractice>) => {
      const index = state.practices.findIndex(
        (practice) => practice.id === action.payload.id,
      )
      if (index !== -1) {
        state.practices[index] = action.payload
      }
    },
    setPracticeInvites: (
      state,
      action: PayloadAction<PracticeInviteWithContext[]>,
    ) => {
      state.practiceInvites = action.payload
    },
    setLinkedInviteId: (state, action: PayloadAction<string>) => {
      state.linkedInviteId = action.payload
    },
    updateDataStatus: (
      state,
      action: PayloadAction<Partial<PracticesDataStatus>>,
    ) => {
      state.dataStatuses = { ...state.dataStatuses, ...action.payload }
    },
  },
})

export const {
  setPractices,
  setDetachedProviders,
  updatePractice,
  setPracticeInvites,
  setLinkedInviteId,
  updateDataStatus,
} = practicesSlice.actions

export default practicesSlice.reducer
